// extracted by mini-css-extract-plugin
module.exports = {"scoreCounter":"_efe385a","counterButton":"_490e445"};